var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeat04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 9.17444 19.1213 6.67091 17 5.12537M13 22.4L11 20.4L13 18.4M12 3.49998C7.30558 3.49998 3.5 7.30555 3.5 12C3.5 14.8255 4.87867 17.329 7 18.8746M11 5.59998L13 3.59998L11 1.59998",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat04);
export default __webpack_public_path__ + "static/media/repeat-04.c0557f5074e0adf50f00cedddfa9e13c.svg";
export { ForwardRef as ReactComponent };